import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelector } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.EstadoDto;
import { columnas } from "./columns";
const resource = resources.Estado
;
export class DireccionEstadoList extends React.PureComponent {

    onBorrar = async (x: Entity) => {
        if (await kea.yesno("¿Borrar el estado?", x.Nombre)) {
            await resource.delete(x.IdRegistro);
        }
    }

    items = observeResource(resource.query, {});
    onEdit = (x: Entity) => history.go(`./${x.IdRegistro}`);
    onAgregar = () => history.go('./new');
    onRegresar = () => history.go('../');

    render() {
        const cols = columnas(this);
        return (
            <div>
                <kea.Title titulo="Estados" onRegresar={this.onRegresar}>
                    <kea.AgregarButton onClick={this.onAgregar} />
                </kea.Title>

                <kea.Grid2 columnas={cols} cookieKey={"EstadosListCookieKey"} items={this.items} />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/DireccionEstado/list/list.tsx